import React, { PureComponent } from 'react';

import uuid from 'uuid/v4';

import { Endpoint, ToastServiceProviderAccreditation } from '@philips-emr/hpms-provider-accreditation-commons';
import { Card, Field, Form, Input, Text } from '@philips-emr/tws-components/lib/components';
import { AwesomeComponent, ComponentType } from '@philips-emr/tws-core';
import { HistoryService, HttpService } from '@philips-emr/tws-core/lib/services';

import './hpms-amount-professionals.css';

@AwesomeComponent({ type: ComponentType.DATA_DISPLAY })
export default class HpmsAmountProfessionalsCard extends PureComponent {

  state = {
    editForm: false,
    record: {},
  };

  componentDidMount() {
    this.setState({ record: this.props });
  }

  render() {
    const { record: data } = this.state;
    const isMandatory = data.mandatory === 'S' ? true : false;
    const modeEdition = this.state.editForm || !!data.amounts ? false : true;
    const locked = data.editable == 'N';

    return(
      <Card width={12} uuid={uuid()} className="card-amount-professionals-style">
        <Form
          locked={locked}
          editing={locked ? false : modeEdition}
          uuid={uuid()}
          data={data}
          onEdit={() => this.setState({ editForm: true })}
          onCancel={() => this.setState({ editForm: false })}
          onSubmit={(event) => this.onSubmit(event)}>
          <Field width={8} uuid={uuid()} alwaysShowLabel label="pa.occupation" entry="dsOccupation">
            <Text />
          </Field>
          { this.state.editForm
          ? <Field width={4} uuid={uuid()} alwaysShowLabel label="pa.amount" entry="amounts" validators={this.getValidatorAmount(isMandatory)}>
              <Input uuid={uuid()} placeholder="pa.amount" type="number" length={10} showLength={false}/>
            </Field>
          : <Field width={4} uuid={uuid()} alwaysShowLabel label="pa.amount" entry="amounts">
              <Input uuid={uuid()} placeholder="pa.amount" type="number" length={10} showLength={false}/>
            </Field>
          }
        </Form>
      </Card>
    );
  }

  getValidatorAmount(isMandatory) {
    return isMandatory ? [{ name: 'required' }] : [];
  }

  onSubmit(event) {
    const { record }  = event;
    const { nrSeqUser, nrSeqAccreditation } = HistoryService.getCurrentRouteParams();
    HttpService.post(Endpoint.POST.AMOUNT_PROFESSIONALS, { nrSeqUser, nrSeqAccreditation }, { body: { ...record } })
    .then(() => {
      this.setState({ editForm: false });
    }).catch(() => ToastServiceProviderAccreditation.error('pa.error-process-request'));
  }
}
